if (typeof FAQAccordion === 'undefined') {
  class FAQAccordion {
    constructor() {
      this.sections = document.querySelectorAll('.faq-accordion');
      this.init();
    }

    init() {
      if (this.sections.length === 0) return;

      this.sections.forEach(section => {
        this.initSection(section);
      });
    }

    initSection(section) {
      const items = section.querySelectorAll('.faq-accordion__item');

      items.forEach(item => {
        if (item.hasAttribute('data-faq-initialized')) return;

        const toggle = item.querySelector('[data-faq-toggle]');
        const answer = item.querySelector('[data-faq-answer]');

        if (!toggle || !answer) return;

        answer.style.maxHeight = '0px';
        toggle.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleItem(item, toggle, answer);
        });

        item.setAttribute('data-faq-initialized', 'true');
      });
    }

    toggleItem(item, toggle, answer) {
      const isOpen = item.classList.contains('is-open');

      if (isOpen) {
        this.closeItem(item, toggle, answer);
      } else {
        const section = item.closest('.faq-accordion');
        const allItems = section.querySelectorAll('.faq-accordion__item');

        allItems.forEach(otherItem => {
          if (otherItem !== item && otherItem.classList.contains('is-open')) {
            const otherToggle = otherItem.querySelector('[data-faq-toggle]');
            const otherAnswer = otherItem.querySelector('[data-faq-answer]');
            this.closeItem(otherItem, otherToggle, otherAnswer);
          }
        });
        this.openItem(item, toggle, answer);
      }
    }

    openItem(item, toggle, answer) {
      const answerInner = answer.querySelector('.faq-accordion__answer-inner');
      const height = answerInner.scrollHeight;
      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      answer.style.maxHeight = height + 'px';
      setTimeout(() => {
        if (item.classList.contains('is-open')) {
          answer.style.maxHeight = 'none';
        }
      }, 400);
    }

    closeItem(item, toggle, answer) {
      const answerInner = answer.querySelector('.faq-accordion__answer-inner');
      const height = answerInner.scrollHeight;
      answer.style.maxHeight = height + 'px';
      answer.offsetHeight;
      answer.style.maxHeight = '0px';
      item.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    handleResize() {
      let resizeTimer;

      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.sections.forEach(section => {
            const openItems = section.querySelectorAll('.faq-accordion__item.is-open');

            openItems.forEach(item => {
              const answer = item.querySelector('[data-faq-answer]');
              const answerInner = answer.querySelector('.faq-accordion__answer-inner');

              if (answer && answerInner) {
                answer.style.maxHeight = 'none';
                const height = answerInner.scrollHeight;
                answer.style.maxHeight = height + 'px';

                setTimeout(() => {
                  if (item.classList.contains('is-open')) {
                    answer.style.maxHeight = 'none';
                  }
                }, 50);
              }
            });
          });
        }, 250);
      });
    }
  }

  function initFAQAccordion() {
    const faqAccordion = new FAQAccordion();
    faqAccordion.handleResize();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFAQAccordion);
  } else {
    initFAQAccordion();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.faq-accordion')) {
        initFAQAccordion();
      }
    });
  }
}